import { render } from "./MenuPlan.vue?vue&type=template&id=59463dac&scoped=true"
import script from "./MenuPlan.vue?vue&type=script&lang=js"
export * from "./MenuPlan.vue?vue&type=script&lang=js"

import "./MenuPlan.vue?vue&type=style&index=0&id=59463dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59463dac"]])

export default __exports__